import ArrowIcon from "@/components/icons/ArrowIcon";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { submitAnswer } from "@/services/product";
import { getCookie } from "cookies-next";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {getSession, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import store from "store";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { object, string } from "yup";
import CloseIcon from "@/components/icons/CloseIcon";

export default function Accordion({
  head,
  body,
  fromPDP = false,
  questionId,
  sku,
  Context,
}) {
  const { locale } = useRouter();
  const handshake = getCookie("handshake");
  const [openModel, setOpenModel] = useState(false);

  const ref = useRef();
  const AddNewAnswerRef = useRef(null);
  useOnClickOutside([ref], () => setOpenModel(false));

  const handleOpenAddAnswerModel = () => setOpenModel(true);

  const answerValidationSchema = () =>
    object({
      answer: string().required(
        locale == "en" ? "Answer can't be empty" : "الاجابة فارغة"
      ),
    });

  const { data: session } = useSession();
  const productFaqAnswer = store.get("productFaqAnswer")
  
  useEffect(() => {
    // store.remove("productFaqAnswer")
    const handleAddingAnswer = async () => {
      const getUpdatedSession = await getSession()
      if (!Context?.state.auth && productFaqAnswer && !getUpdatedSession?.user?.id) {
        store.remove("productFaqAnswer")
        return
      }
      !Context?.state.auth && AddNewAnswerRef && AddNewAnswerRef?.current?.click()
    }
    
    Object.keys(session || {})?.length && !Context?.state.auth && productFaqAnswer && handleAddingAnswer()
  }, [productFaqAnswer, Context?.state.auth, session])

  async function handleSubmitAnswer(values) {
    if (session) {
      const res = await submitAnswer(
        questionId,
        sku,
        values?.answer,
        session ? session.user.id : "",
        handshake
      );
      if (res.status == 200) {
        toast.success(res?.data?.data?.message);
        setOpenModel(false);
      } else {
        toast.error(res?.error?.error?.message);
      }
      store.remove("productFaqAnswer")
      return
    }
    store.set("productFaqAnswer", {
      questionId,
      sku,
      answer: values?.answer,
    })
    Context?.dispatch({ type: "auth" });
  }

  return (
    <div className="space-y-4">
      <details className="group [&_summary::-webkit-details-marker]:hidden">
        <summary className="flex cursor-pointer items-center justify-between rounded-lg  p-2 text-gray-900 gap-5">
          <ArrowIcon
            className={`size-3 ${
              locale === "ar" && "rotate-180"
            } group-open:rotate-90 transition-all`}
          />
          <h2
            className={`${
              fromPDP ? "group-open:font-bold" : "font-semibold"
            } flex justify-between w-full`}
          >
            {head}
            <span className="text-xs sm:text-lg whitespace-nowrap font-semibold">
              {body?.length} {locale == "en" ? "Answers" : body?.length == 1 ? "اجابة" : "اجابات"}
            </span>
          </h2>
        </summary>
        {fromPDP ? (
          <>
            <button
              onClick={handleOpenAddAnswerModel}
              className="items-center gap-2 mx-10 text-sm sm:text-[15px] px-8 py-2 text-purple-500 rounded-md bg-transparent border-2 border-purple-300"
            >
              {locale == "en" ? "Add Answer" : "أضف اجابة"}
            </button>

            {body?.map((answer, key) => (
              <p
                key={key}
                className="my-3 py-2 px-4 max-sm:flex max-sm:flex-col max-sm:justify-center leading-relaxed bg-[#F8F7F7] text-gray-700"
              >
                {answer}
              </p>
            ))}
            {openModel ? (
              <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black bg-opacity-60 z-modal">
                <div
                  ref={ref}
                  className="col-span-full lg:col-span-3 h-fit bg-[#F8F7F7] p-3"
                >
                  <div className="flex items-center justify-between text-sm sm:text-lg mb-3 text-[#744A91] font-bold">
                    <h2 className="font-bold sm:text-xl">
                      {locale == "en" ? "Add Answer" : "أضف اجابة"}
                    </h2>
                    <CloseIcon
                      onClick={() => setOpenModel(false)}
                      className="cursor-pointer text-secondary-800 size-3"
                    />
                  </div>
                  <Formik
                    initialValues={{ answer: "" }}
                    validationSchema={answerValidationSchema}
                    onSubmit={handleSubmitAnswer}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        <Field
                          as="textarea"
                          className="block w-full p-2 bg-white rounded-sm resize-none sm:p-4"
                          rows="5"
                          name="answer"
                        />
                        <ErrorMessage
                          component="p"
                          name="answer"
                          className="text-red-500"
                        />
                        <button
                          ref={AddNewAnswerRef}
                          type="submit"
                          disabled={isSubmitting}
                          className="flex justify-center items-center gap-2 w-11/12 text-sm sm:text-[15px] p-1 mx-auto text-white rounded-md bg-primary"
                        >
                          {isSubmitting && (
                            <div className="loader w-6 text-white" />
                          )}
                          <p>
                            {locale == "en"
                              ? "Submit a New Answer"
                              : "أضف اجابة جديدة"}
                          </p>
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <p className="py-2 px-4 max-sm:flex max-sm:flex-col max-sm:justify-center leading-relaxed bg-[#F8F7F7] text-gray-700">
            {body}
          </p>
        )}
      </details>
    </div>
  );
}
